export interface GenerateTableColumn {
    header?: string;
    headerTooltip?: string;
    tdClass?: string;
    thClass?: string;
    attr?: string;
    template?: Function;
    show?: boolean;
    click?: {
      disabled?: Function,
      action?: Function
    },
    btnProps?: {
        label: string,
        color?: 'primary' | 'accent' | 'warn',
        show?: Function,
    }
}

export interface GenerateTablePageEvent { 
    current: number,    
    pageSize: number,
}

export interface GenerateTablePagination {
    total: number,
    current: number,
    pageSize: number
}